
const state = {
    cars: [{ chassis: null, price: null}]
}

const getters = {
    getInvoiceCars: (state) => {
        return state.cars
    }
}

const mutations = {
    pushToInvoiceEmptyCar: (state) => {
        state.cars.push({ chassis: null, price: null })
    },
    spliceInvoiceCarByIndex: (state, index) => {
        state.cars.splice(index, 1)
    },


}

const actions = {
    addEmptyRowToInvoice: ({ commit }) => {
        commit('pushToInvoiceEmptyCar')
    },
    removeRowFromInvoice: ({ commit }, index) => {
        commit('spliceInvoiceCarByIndex', index)
    },
}

export default { state, getters, mutations, actions }


// WEBPACK FOOTER //
// ./src/store/modules/invoice.js